"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appTheme = exports.typography = exports.appOverrides = exports.appColors = exports.appPalette = void 0;
var tslib_1 = require("tslib");
var _colors_1 = require("./_colors");
var core_1 = require("@material-ui/core");
exports.appPalette = {
    primary: {
        light: _colors_1.darkMediumBlue,
        main: _colors_1.darkBlue,
        dark: _colors_1.darkGreenBlue,
    },
    success: {
        main: _colors_1.mediumGreen,
        dark: _colors_1.darkGreen,
    },
    error: {
        main: _colors_1.mediumRed,
    },
    info: {
        light: _colors_1.lightLightBlue,
        main: _colors_1.mediumLightBlue,
        dark: _colors_1.mediumBlue,
    },
};
exports.appColors = {
    white: _colors_1.white,
    lightBlue: _colors_1.lightBlue,
    darkerGrey: _colors_1.darkerGrey,
    darkMediumGrey: _colors_1.darkMediumGrey,
    lightGrey: _colors_1.lightGrey,
};
exports.appOverrides = {
    MuiIconButton: {
        root: {
            padding: '16px',
            '&&.Mui-disabled': {
                color: 'inherit',
                opacity: 0.3,
            },
        },
    },
    MuiButton: {
        containedPrimary: {
            color: exports.appColors.white,
            backgroundColor: _colors_1.mediumGreen,
            borderRadius: 4,
            fontSize: 18,
            '&:hover': {
                backgroundColor: _colors_1.darkGreen,
            },
        },
        containedSecondary: {
            color: exports.appColors.white,
            backgroundColor: _colors_1.darkBlue,
            borderRadius: 4,
            '&:hover': {
                backgroundColor: _colors_1.mediumLightBlue,
            },
        },
    },
    MuiCircularProgress: {
        colorPrimary: {
            color: _colors_1.mediumGreen,
        },
    },
    MuiSnackbar: {
        root: {
            borderRadius: '8px',
        },
        anchorOriginTopCenter: {
            top: '16px',
            left: '16px',
            right: '16px',
        },
    },
};
var generateTypographyStyles = function (fontSize, fontWeight) {
    if (fontWeight === void 0) { fontWeight = 400; }
    return ({
        fontSize: fontSize,
        fontWeight: fontWeight,
    });
};
exports.typography = {
    fontFamily: 'Roboto',
    h1: tslib_1.__assign({}, generateTypographyStyles('2.25em')),
    h2: tslib_1.__assign({}, generateTypographyStyles('2em')),
    h3: tslib_1.__assign({}, generateTypographyStyles('1.81em')),
    h4: tslib_1.__assign({}, generateTypographyStyles('1.62em')),
    h5: tslib_1.__assign({}, generateTypographyStyles('1.43em')),
    h6: tslib_1.__assign({}, generateTypographyStyles('1.31em')),
    subtitle1: tslib_1.__assign({}, generateTypographyStyles('1.125em')),
    body1: tslib_1.__assign({}, generateTypographyStyles('1em')),
    body2: tslib_1.__assign({}, generateTypographyStyles('0.875em')),
    caption: tslib_1.__assign({}, generateTypographyStyles('0.75em')),
    button: tslib_1.__assign({}, generateTypographyStyles('1em', 500)),
};
exports.appTheme = core_1.createMuiTheme({
    palette: exports.appPalette,
    colors: exports.appColors,
    overrides: exports.appOverrides,
    typography: exports.typography,
});
